<script setup lang="ts">
import type { BannerFaqInlineProps } from "./FaqInline.props"

withDefaults(defineProps<BannerFaqInlineProps>(), {
  iconName: "Comment.svg"
})

const emit =
  defineEmits<{
    (e: "linkClick"): void
  }>()
</script>

<template>
  <div
    class="
      mb-4
      md:mb-0
      md:mt-8
      md:flex
      md:items-center
      md:justify-between
      md:gap-14
    "
  >
    <div class="flex items-center gap-3">
      <div class="bg-tiffany-30 relative h-10 w-10 shrink-0 rounded-full">
        <UtilsIcon
          :name="iconName"
          class="absolute -bottom-1 -right-2 h-8 w-auto"
          fetch-priority="high"
        />
      </div>
      <UtilsMarkdown
        :content="title"
        class="pig-bold md:dolphin-bold lg:pig-bold ms-3"
        :inline="true"
      />
    </div>
    <button
      @click="emit('linkClick')"
      class="
        beaver-medium
        text-green-main
        border-green-main
        mt-4
        flex-1
        cursor-pointer
        whitespace-nowrap
        rounded-lg
        border
        px-4
        py-3
        text-center
        md:ms-4
        md:mt-0
        md:max-w-prose
        md:py-2
      "
    >
      {{ text }}
    </button>
  </div>
</template>
